import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg, { getOrganizationSchema, getWebsiteSchema, getWebPageSchema, getBreadcrumbSchema, getFAQSchema } from '@/components/feature/SchemaOrg';
import HeroSection from './components/HeroSection';
import HotRankingSection from './components/HotRankingSection';
import LatestSection from './components/LatestSection';
import TestimonialSection from './components/TestimonialSection';
import CtaSection from './components/CtaSection';

const homeFaqs = [
  { question: '韩漫漫画网是免费的吗？', answer: '是的！韩漫漫画网所有漫画均为免费在线阅读，无需付费即可畅享海量韩漫资源。我们持续为读者提供优质的免费阅读体验。' },
  { question: '漫画多久更新一次？', answer: '热门漫画通常每周更新一到两次，部分作品与韩国同步更新。您可以在漫画详情页查看具体的更新频率和最新话数。' },
  { question: '支持手机阅读吗？', answer: '完全支持！韩漫漫画网采用响应式设计，完美适配手机、平板和电脑等多种设备。下拉式阅读方式在手机上体验特别流畅。' },
  { question: '如何找到想看的漫画？', answer: '您可以通过分类导航浏览不同题材的漫画，也可以使用搜索功能直接查找。智能推荐系统还会根据您的阅读历史推送个性化内容。' },
];

export default function Home() {
  return (
    <>
      <SchemaOrg type="Organization" data={getOrganizationSchema()} />
      <SchemaOrg type="WebSite" data={getWebsiteSchema()} />
      <SchemaOrg type="WebPage" data={getWebPageSchema(
        '韩漫漫画网-免费漫画大全-好看的韩国漫画推荐-无遮挡下拉式韩漫在线阅读',
        '韩漫漫画网提供免费漫画大全，好看的韩国漫画推荐结合无遮挡下拉式在线阅读，智能推送个性化内容，让您发现新喜好。',
        'http://linxituan.com/'
      )} />
      <SchemaOrg type="BreadcrumbList" data={getBreadcrumbSchema([
        { name: '首页', url: 'http://linxituan.com/' },
      ])} />
      <SchemaOrg type="FAQPage" data={getFAQSchema(homeFaqs)} />
      <Navbar />
      <main>
        <HeroSection />
        <HotRankingSection />
        <LatestSection />
        <TestimonialSection />
        <CtaSection />
      </main>
      <Footer />
    </>
  );
}